(function () {
  const sections = document.querySelectorAll('[data-tbh-shop-the-look]');
  if (!sections.length) return;

  const closeTimers = new WeakMap();
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const closeAnimationMs = 180;

  function clearCloseTimer(card) {
    const timer = closeTimers.get(card);
    if (!timer) return;

    window.clearTimeout(timer);
    closeTimers.delete(card);
  }

  function closeCard(card) {
    const dialog = card.querySelector('[data-tbh-look-dialog]');
    const trigger = card.querySelector('[data-tbh-look-trigger]');
    if (!dialog || !trigger) return;

    clearCloseTimer(card);
    card.removeAttribute('data-dialog-open');
    trigger.setAttribute('aria-expanded', 'false');

    if (prefersReducedMotion.matches) {
      dialog.hidden = true;
      return;
    }

    const timer = window.setTimeout(() => {
      if (!card.hasAttribute('data-dialog-open')) dialog.hidden = true;
      closeTimers.delete(card);
    }, closeAnimationMs);

    closeTimers.set(card, timer);
  }

  function closeOtherCards(currentCard) {
    document.querySelectorAll('[data-tbh-look-card][data-dialog-open]').forEach((card) => {
      if (card !== currentCard) closeCard(card);
    });
  }

  function placeDialog(card) {
    const trigger = card.querySelector('[data-tbh-look-trigger]');
    const dialog = card.querySelector('[data-tbh-look-dialog]');
    if (!trigger || !dialog) return;

    const viewportGutter = 24;
    const dialogOffset = 16;
    const cardRect = card.getBoundingClientRect();
    const triggerRect = trigger.getBoundingClientRect();
    const triggerCenterX = triggerRect.left + triggerRect.width / 2 - cardRect.left;
    const triggerCenterY = triggerRect.top + triggerRect.height / 2 - cardRect.top;
    const previousVisibility = dialog.style.visibility;
    const previousDisplay = dialog.style.display;

    dialog.style.visibility = 'hidden';
    dialog.style.display = 'block';
    dialog.style.maxWidth = '';

    const dialogRect = dialog.getBoundingClientRect();
    const naturalDialogWidth = dialogRect.width;

    dialog.style.visibility = previousVisibility;
    dialog.style.display = previousDisplay;

    const availableRight = window.innerWidth - triggerRect.right - viewportGutter;
    const availableLeft = triggerRect.left - viewportGutter;
    let horizontal = 'right';

    if (availableRight >= naturalDialogWidth + dialogOffset) {
      horizontal = 'right';
    } else if (availableLeft >= naturalDialogWidth + dialogOffset) {
      horizontal = 'left';
    } else {
      horizontal = availableLeft > availableRight ? 'left' : 'right';
    }

    const maxAvailableWidth = Math.max(
      160,
      (horizontal === 'left' ? availableLeft : availableRight) - dialogOffset
    );
    dialog.style.maxWidth = `${maxAvailableWidth}px`;

    const vertical = triggerCenterY > cardRect.height * 0.58 ? 'top' : 'bottom';

    dialog.dataset.placement = `${horizontal}-${vertical}`;
  }

  sections.forEach((section) => {
    section.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element ? event.target.closest('[data-tbh-look-trigger]') : null;
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();

      const card = trigger.closest('[data-tbh-look-card]');
      const dialog = card?.querySelector('[data-tbh-look-dialog]');
      if (!card || !dialog) return;

      const willOpen = dialog.hidden || !card.hasAttribute('data-dialog-open');
      closeOtherCards(card);

      if (!willOpen) {
        closeCard(card);
        return;
      }

      clearCloseTimer(card);
      dialog.hidden = false;
      placeDialog(card);

      window.requestAnimationFrame(() => {
        card.setAttribute('data-dialog-open', 'true');
        trigger.setAttribute('aria-expanded', 'true');
      });
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('[data-tbh-shop-the-look]')) return;
    document.querySelectorAll('[data-tbh-look-card][data-dialog-open]').forEach(closeCard);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-tbh-look-card][data-dialog-open]').forEach(closeCard);
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-tbh-look-card][data-dialog-open]').forEach(placeDialog);
  });
})();
